import { Flex, Radio, Select } from "@theorgchartdev/storybook";
import { FieldSelectListProps } from "@/Utils/ComponentLib";
import { GetWSMgr, ReRenderCanvas } from "@/Utils/StateLib";
import { ScOptions } from "@/appComponents/Navigation/RightSidebar/Optimize/Optimize.utils";
import {
  BuildDensityOptions,
  BuildBreakFieldOptions,
  BuildMinSubBreakOptions,
  BuildNameUsingOptions,
  BuildBreaksEveryOptions,
  BuildBreaksAtOptions
} from "@/appComponents/Navigation/RightSidebar/Optimize/Optimize.utils";
import { enumFeaturesList, enumSubChartOption } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { appstrp } from "@coreapp/utils/appstrp";
import { getFeatureAccess } from "@/Utils/Misc";

/**
 *
 * @param {*} props
 * @returns React.ReactNode
 */
export const PaginationConfig = ({
  scConfig,
  handleUpdate,
  applyNode = undefined,
  useExportModalStyle = false,
  useSettingModalStyle = false,
  disabled = false,
  showAsIs = false,
  fieldNames = [],
  showNameUsing = true
}) => {
  const showStartBreaksAt = [
    enumSubChartOption.autobreaks,
    enumSubChartOption.breakbylevel,
    enumSubChartOption.breakbyfield,
    enumSubChartOption.renameall
  ].includes(scConfig.scChartBreakType);
  const showMinSubsBreak = [
    enumSubChartOption.breakbylevel,
    enumSubChartOption.breakbyfield
  ].includes(scConfig.scChartBreakType);

  const size = useSettingModalStyle || useExportModalStyle ? "medium" : "small";

  const w = GetWSMgr();
  const doc = w.GetDoc();
  const availableFieldNames = fieldNames ?? [];
  const disabledAutoBreaks = !getFeatureAccess(enumFeaturesList.autoSubchartBreaks);

  return (
    <Flex
      direction="column"
      gap="12px"
      width={"100%"}
      padding={useSettingModalStyle || useExportModalStyle ? null : "16px 0 0 0"}
    >
      <Flex direction="column" gap={"8px"}>
        {ScOptions(showAsIs).map(([label, value]) => (
          <Radio
            disabled={disabled}
            key={`subchart-option-${value}`}
            data-testid={"pagination-break--" + label}
            id={`subchart-option-${value}`}
            label={`${appstr(label)}`}
            value={value}
            checked={value === scConfig.scChartBreakType}
            onChange={() => handleUpdate("scChartBreakType", value)}
          />
        ))}
      </Flex>
      <Flex
        padding={"0 0 0 32px"}
        direction={"column"}
        width={useSettingModalStyle ? "400px" : null}
        gap={"8px"}
      >
        {showNameUsing && (
          <Select
            disabled={disabled}
            dataTestId={"pagination-name-using"}
            inputOnly={false}
            value={scConfig.nameusing}
            placeholder={appstr("selectf")}
            label={appstrp("namescusing", ":")}
            listProps={FieldSelectListProps()}
            optionSize={size}
            selectSize={size}
            options={BuildNameUsingOptions(availableFieldNames, handleUpdate)}
          />
        )}
        {showStartBreaksAt && (
          <Select
            disabled={disabled}
            dataTestId={"pagination-start-breaks-at"}
            inputOnly={false}
            value={scConfig.startbreaksat}
            placeholder={appstr("smartstartlevel")}
            label={appstr("smartstartlevel")}
            selectSize={size}
            optionSize={size}
            options={BuildBreaksAtOptions(handleUpdate)}
          />
        )}
        {scConfig.scChartBreakType === enumSubChartOption.autobreaks && (
          <Select
            disabled={disabledAutoBreaks}
            dataTestId={"pagination-page-density"}
            inputOnly={false}
            value={scConfig.pagedensity}
            placeholder={appstr("pagedensity")}
            label={appstr("pagedensity")}
            selectSize={size}
            optionSize={size}
            options={BuildDensityOptions(handleUpdate)}
          />
        )}
        {scConfig.scChartBreakType === enumSubChartOption.breakbylevel && (
          <Select
            disabled={disabled}
            dataTestId="pagination-break-every"
            inputOnly={false}
            value={scConfig.breakevery}
            placeholder={appstr("breakevery")}
            label={appstr("breakevery")}
            selectSize={size}
            optionSize={size}
            options={BuildBreaksEveryOptions(handleUpdate)}
          />
        )}
        {scConfig.scChartBreakType === enumSubChartOption.breakbyfield && (
          <Select
            disabled={disabled}
            dataTestId="pagination-break-field"
            inputOnly={false}
            value={scConfig.breakfield}
            placeholder={appstr("breakfield")}
            label={appstr("breakfield")}
            selectSize={size}
            optionSize={size}
            listProps={FieldSelectListProps()}
            options={BuildBreakFieldOptions(availableFieldNames, handleUpdate)}
          />
        )}
        {showMinSubsBreak && (
          <Select
            disabled={disabled}
            dataTestId="pagination-min-subs-break"
            inputOnly={false}
            value={scConfig.minsubsforbreak}
            placeholder={appstr("minbreak")}
            labelInfo={appstr("minsubbreaksinfo")}
            label={appstr("minbreak")}
            selectSize={size}
            optionSize={size}
            options={BuildMinSubBreakOptions(handleUpdate)}
          />
        )}
      </Flex>
      {applyNode}
    </Flex>
  );
};
